/** 表格单元格支持的垂直对齐方式。 */
type TableTextVerticalAlign = 'top' | 'center' | 'bottom';

/** 计算 Canvas alphabetic baseline 所需的字体包围盒指标。 */
interface TableTextFontMetrics {
    fontBoundingBoxAscent: number;
    fontBoundingBoxDescent: number;
}

// AlibabaPuHuiTi-Regular OS/2.yStrikeoutPosition / unitsPerEm (35 / 1000).
const TABLE_TEXT_LINE_THROUGH_OFFSET_RATIO = 0.35;

/** 根据单元格垂直对齐方式计算整段文本行盒的起始位置。 */
export const getTableTextStartY = (
    container: { top: number; height: number },
    verticalAlign: TableTextVerticalAlign,
    contentHeight: number,
) => {
    switch (verticalAlign) {
        case 'top':
            return container.top;
        case 'bottom':
            return container.top + container.height - contentHeight;
        case 'center':
        default:
            return container.top + (container.height - contentHeight) / 2;
    }
};

/** 将行盒顶部转换为 Canvas `alphabetic` baseline。 */
export const getTableTextLineVerticalPosition = (
    lineBoxTop: number,
    lineHeight: number,
    metrics: TableTextFontMetrics,
) => {
    const halfLeading = (lineHeight - metrics.fontBoundingBoxAscent - metrics.fontBoundingBoxDescent) / 2;
    const baselineY = lineBoxTop + halfLeading + metrics.fontBoundingBoxAscent;

    return { baselineY };
};

/** 计算下划线相对基线的位置。 */
export const getTableTextUnderlineY = (baselineY: number, fontSize: number) => baselineY + fontSize * 0.1;

/** 计算删除线相对基线的位置。 */
export const getTableTextLineThroughY = (baselineY: number, fontSize: number) =>
    baselineY - fontSize * TABLE_TEXT_LINE_THROUGH_OFFSET_RATIO;

/** 让文本装饰线宽随字号缩放，同时至少保持一个像素。 */
export const getTableTextDecorationLineWidth = (fontSize: number) => Math.max(1, fontSize / 10);
